// Testi della sezione Competitor: codici di errore del backend/worker e stati.

import { testoErrore as testoErroreMarche } from '../brandimport/testi';

export const MAX_SITI = 6;

export const ERRORI = {
	max_sites: `Puoi inserire al massimo ${MAX_SITI} siti.`,
	job_already_running: "C'è già un'operazione in corso per questo sito.",
	site_not_found: 'Sito non trovato.',
	product_not_found: 'Prodotto non trovato.',
	item_not_found: 'Prodotto del catalogo non trovato.',
	variant_not_found: 'Variante non trovata.',
	invalid_price: 'Prezzo non valido.',
	invalid_url: 'URL non valido: deve iniziare con http:// o https://.',
	no_structured_price: 'Il sito non espone il prezzo nei dati strutturati.',
	no_product_urls: 'Nessuna pagina prodotto trovata (né nella sitemap né navigando il sito): configura la navigazione del sito nelle regole oppure controlla sitemap e filtri URL.',
	requires_browser: 'Le pagine non contengono i dati nell’HTML: imposta la modalità Browser nelle opzioni avanzate e riprova.',
	blocked: 'Il sito ha bloccato le richieste. La scansione è stata fermata.',
	blocked_forbidden: 'Il sito ha rifiutato le richieste (403). La scansione è stata fermata.',
	blocked_challenge: 'Il sito ha una protezione anti-bot. La scansione è stata fermata.',
	blocked_rate_limit: 'Il sito limita le richieste. La scansione è stata fermata.',
	robots_disallow: 'Il robots.txt del sito vieta la lettura delle pagine.',
	url_not_allowed: 'Indirizzo non ammesso.',
	enqueue_failed: 'Impossibile mettere in coda l’operazione, riprova.',
	worker_lost: 'Il processo si è interrotto: riprova.',
	internal_error: 'Errore interno.',
	// regole di estrazione (AI + taratura)
	openai_not_configured: 'OpenAI non è attivo: configuralo in Impostazioni > AI.',
	rules_not_tested: 'Prova le regole sui campioni prima di attivarle.',
	rules_not_found: 'Regole non trovate.',
	url_other_site: 'La pagina deve essere del sito concorrente.',
	structure_changed: 'Il sito concorrente è cambiato: controlla e conferma le nuove regole.',
	not_a_shop: 'Le pagine trovate non hanno prezzo, SKU o EAN: controlla sitemap e filtri URL.',
	no_pages: 'Nessuna pagina campione scaricabile.',
	page_not_found: 'Pagina non trovata.',
};

// codici non previsti qui (es. openai_rate_limit) usano i testi di Import da marchi
export const testoErrore = err => {
	if (!err) return '';
	if (typeof err === 'string') return ERRORI[err] || testoErroreMarche(err);
	if (Array.isArray(err.error) && err.error.length) {
		return err.error.map(e => (typeof e === 'string' ? e : e.msg)).join(' · ');
	}
	return ERRORI[err.message] || testoErroreMarche(err);
};

export const TIPI_JOB = {
	competitor_scan: 'Scansione',
	competitor_match: 'Abbinamento',
	scan: 'Scansione',
	match: 'Abbinamento',
	generate_rules: 'Generazione regole',
	preview_rules: 'Prova regole',
	snapshot: 'Copia pagina per la taratura',
};

// job che non rappresentano lo stato del sito (seguiti solo dal dialog di taratura)
export const TIPI_JOB_INTERNI = ['snapshot'];

export const STATI_JOB = {
	queued: { testo: 'In coda', colore: 'grey' },
	running: { testo: 'In corso', colore: 'primary' },
	done: { testo: 'Completato', colore: 'success' },
	failed: { testo: 'Non riuscito', colore: 'error' },
	blocked: { testo: 'Bloccato dal sito', colore: 'error' },
	needs_review: { testo: 'Da rivedere', colore: 'warning' },
	cancelled: { testo: 'Annullato', colore: 'grey' },
};

export const STATI_SITO = {
	ok: { testo: 'Attivo', colore: 'success' },
	blocked: { testo: 'Bloccato', colore: 'error' },
	requires_browser: { testo: 'Serve browser', colore: 'warning' },
	error: { testo: 'Errore', colore: 'error' },
};

export const METODI_MATCH = {
	ean: { testo: 'EAN', colore: 'success' },
	sku: { testo: 'SKU', colore: 'success' },
	mpn: { testo: 'MPN', colore: 'success' },
	ai: { testo: 'AI', colore: 'deep-purple' },
	manual: { testo: 'Manuale', colore: 'primary' },
};

export const CONTATORI = {
	found: 'trovati',
	urls: 'URL',
	pages: 'pagine',
	processed: 'letti',
	saved: 'salvati',
	created: 'nuovi',
	updated: 'aggiornati',
	unchanged: 'invariati',
	gone: 'spariti',
	matched: 'abbinati',
	unmatched: 'non abbinati',
	errors: 'errori',
};

export const attivo = job => !!job && (job.status === 'queued' || job.status === 'running');

// testo leggibile di un messaggio del worker (codice noto o testo libero)
export const testoMessaggio = job => {
	if (!job) return '';
	const m = job.error || job.message;
	if (!m) return '';
	if (typeof m === 'string') return testoErrore(m);
	return testoErrore(m);
};
